import React from 'react'
import classNames from 'classnames'

export interface TabbedScrollIndicatorsProps {
  showLeft: boolean
  showRight: boolean
  scrollByPage: (dir: number) => void
}

const TabbedScrollIndicators: React.FC<TabbedScrollIndicatorsProps> = ({ showLeft, showRight, scrollByPage }) => {
  const leftClassname = classNames('tabbed-nav__scroll-indicator', 'scroll-indicator', 'scroll-indicator--left', {
    'is-visible': showLeft,
  })
  const rightClassname = classNames('tabbed-nav__scroll-indicator', 'scroll-indicator', 'scroll-indicator--right', {
    'is-visible': showRight,
  })

  return (
    <>
      <a className={leftClassname} onClick={() => scrollByPage(-1)} aria-label="Scroll left" aria-hidden={!showLeft}>
        <div className="arrow">❮</div>
      </a>
      <a className={rightClassname} onClick={() => scrollByPage(1)} aria-label="Scroll right" aria-hidden={!showRight}>
        <div className="arrow">❯</div>
      </a>
    </>
  )
}

export default TabbedScrollIndicators
